module.exports = __webpack_public_path__ + "static/media/fal_fal_ope_hol.4e8a5923.png";